var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hitchRideWithdrawalRule"},[_c('custom-org-tree',{ref:"customTree",attrs:{"url":"/api/v1/manage/hitchRide/withdrawalConfig"},on:{"selected":_vm.handleSelect}}),_c('div',{staticClass:"hitchRideWithdrawalRule-content"},[_c('driverWithdrawal',{attrs:{"rowData":{ ..._vm.selectCity }},on:{"refresh":_vm.refresh}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }